import { DOCUMENT_SIGNING_STATUSES } from "../constants";
import { SignedDocument } from "../types";

export const getIsDocumentSigned = (document: SignedDocument) =>
  document.documentStatus.status === DOCUMENT_SIGNING_STATUSES.SUCCESS &&
  !document.signatureInfo.error &&
  !document.documentStatus.errorText;
